module.exports = __webpack_public_path__ + "img/28.a3fa2ebd.jpg";